module.exports = __webpack_public_path__ + "img/2.844d80b8.png";